import React, { useState, useEffect, useRef } from 'react';
import './FactoryPageHeader.css';

/* 공장 모니터링 화면 공통 헤더 — PNG 시안「사출기 현황」「실시간 샷 현황」.
 * "🏭 전사 › [공장 ▾] › 화면 이름" + 오른쪽 동기화 시각 · 새로 고침. 공장 사출 현황(Factory.jsx fo-header)과 같은 모양.
 * allowAll 이면 공장 목록 맨 위에 "전체" 항목을 두고 selectedFactoryId=null 로 고른다. 스타일은 fph- 접두어. */

const pad2 = (n) => String(n).padStart(2, '0');
export const formatHeaderTime = (d) => {
  if (!d) return '—';
  const x = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(x.getTime())) return '—';
  return `${x.getFullYear()}-${pad2(x.getMonth() + 1)}-${pad2(x.getDate())} ${pad2(x.getHours())}:${pad2(x.getMinutes())}:${pad2(x.getSeconds())}`;
};

function FactoryPageHeader({
  rootLabel, factories = [], selectedFactoryId, onSelectFactory, allowAll = false, allLabel,
  pageLabel, syncTime, onRefresh, refreshTitle, refreshing = false
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  const current = factories.find((f) => f.id === selectedFactoryId);
  const label = current ? current.factoryName : (allowAll ? allLabel : '—');
  const pick = (id) => { setOpen(false); if (onSelectFactory) onSelectFactory(id); };

  return (
    <div className="fph-header">
      <div className="fph-breadcrumb">
        <span className="material-symbols-outlined fph-icon">factory</span>
        <span className="fph-root">{rootLabel}</span>
        <span className="material-symbols-outlined fph-sep">chevron_right</span>
        <div className="fph-select" ref={ref}>
          <button type="button" className="fph-trigger" onClick={() => setOpen((v) => !v)}>
            <span>{label}</span>
            <span className="material-symbols-outlined">{open ? 'expand_less' : 'expand_more'}</span>
          </button>
          {open && (
            <div className="fph-menu">
              {allowAll && (
                <button type="button" className={`fph-item ${selectedFactoryId == null ? 'active' : ''}`} onClick={() => pick(null)}>
                  <span className="fph-item-name">{allLabel}</span>
                </button>
              )}
              {factories.map((f) => (
                <button type="button" key={f.id} className={`fph-item ${f.id === selectedFactoryId ? 'active' : ''}`} onClick={() => pick(f.id)}>
                  <span className="fph-item-name">{f.factoryName}</span>
                  {f.address && <span className="fph-item-sub">{f.address}</span>}
                </button>
              ))}
            </div>
          )}
        </div>
        <span className="material-symbols-outlined fph-sep">chevron_right</span>
        <span className="fph-page">{pageLabel}</span>
      </div>
      <div className={`fph-right ${refreshing ? 'refreshing' : ''}`}>
        <span className="fph-time">{formatHeaderTime(syncTime)}</span>
        <button type="button" className="fph-refresh" onClick={onRefresh} title={refreshTitle} aria-label={refreshTitle}>
          <span className="material-symbols-outlined">refresh</span>
        </button>
      </div>
    </div>
  );
}

export default FactoryPageHeader;
